import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-front-promotion',
  templateUrl: './front-promotion.component.html',
  styleUrls: ['./front-promotion.component.scss']
})
export class FrontPromotionComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/promotion", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Type', type: 'string', key: 'type'}, 
            {label: 'From', type: 'date', key: 'from_date'}, 
            {label: 'To', type: 'date', key: 'to_date'}, 
            {label: 'Sort', type: 'number', key: 'sort'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + "/front/promotion/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_promotion', title: 'title', hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

}
